<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <Table :showTitle="true" ref="table" :isCompanyView="false"/>
    </v-col>
  </v-row>
</template>

<script>
//import Vue from 'vue'
import Table from "../tables/TableMails"
export default {
  name: 'Mails',
  components: {Table},
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
